import { render, staticRenderFns } from "./PolicyLink.vue?vue&type=template&id=46b424d8&scoped=true&"
import script from "./PolicyLink.vue?vue&type=script&lang=js&"
export * from "./PolicyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b424d8",
  null
  
)

component.options.__file = "PolicyLink.vue"
export default component.exports